import { atom } from 'jotai';

export const openUnblockDeviceModalAtom = atom(false);
